var _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFooterStoreDivider = function SvgFooterStoreDivider(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 6.55802,
    height: 0.380318,
    viewBox: "0 0 6.55802 0.380318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    y1: 0.190159,
    x2: 6.55802,
    y2: 0.190159,
    stroke: "#54555B",
    strokeWidth: 0.380318
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterStoreDivider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/footer-store-divider.493f14c1747e9139484056704c36c145.svg";